<template>
	<v-dialog v-model="show" max-width="350px" @click:outside="$emit('close')">
		<v-card>
			<v-card-title class="title primary--text mb-2 secondary">
				<translate v-if="!edit" key="add-record">Add Record</translate>
        <translate v-else key="edit-record">Edit Record</translate>
			</v-card-title>
			<v-card-text>
				<v-form ref="form">
					<v-row no-gutters>
						<v-col cols="12" class="text-subtitle-1">
							<v-row no-gutters>
								<translate>Day</translate>
								<v-spacer></v-spacer>
								<v-menu
									v-model="dateMenu"
									:close-on-content-click="false"
									:nudge-right="40"
									transition="scale-transition"
									offset-y
									min-width="290px"
								>
									<template v-slot:activator="{ on }">
										<v-text-field
											v-model="record.date"
											append-icon="event"
											readonly
											v-on="on"
											outlined
											:rules="dateRules"
											dense
											style="max-width: 150px"
										></v-text-field>
									</template>
									<v-date-picker color="primary" v-model="record.date" @input="dateMenu = false"></v-date-picker>
								</v-menu>
							</v-row>
						</v-col>
						<v-col cols="12" class="text-subtitle-1">
							<v-row no-gutters>
								<translate>Hour</translate>
								<v-spacer></v-spacer>
								<v-menu
									ref="menu"
									v-model="timeMenu"
									:close-on-content-click="false"
									:nudge-right="40"
									:return-value.sync="record.time"
									transition="scale-transition"
									offset-y
									max-width="290px"
									min-width="290px"
								>
									<template v-slot:activator="{ on }">
										<v-text-field
											v-model="record.time"
											append-icon="access_time"
											readonly
											v-on="on"
											outlined
											:rules="timeRules"
											dense
											style="max-width: 150px"
										></v-text-field>
									</template>
									<v-time-picker
										v-if="timeMenu"
										v-model="record.time"
										full-width
										@click:minute="$refs.menu.save(record.time)"
										format="24hr"
									></v-time-picker>
								</v-menu>
							</v-row>
						</v-col>
						<v-col cols="12" class="text-subtitle-1">
							<v-row no-gutters align="center">
								<translate>Intensity</translate>
								<v-spacer></v-spacer>
							</v-row>
						</v-col>
						<v-col cols="12" class="text-subtitle-1 mt-2">
							<div class="text-center">
								<v-rating
									v-model="record.intensity"
									length="11"
									empty-icon="mdi-checkbox-blank-circle-outline"
									full-icon="mdi-checkbox-blank-circle"
									hover
									dense
									:color="intensityColor"
									background-color="secondary"
								></v-rating>
								<div>{{record.intensity - 1}}</div>
							</div>
						</v-col>
					</v-row>
				</v-form>
			</v-card-text>
			<v-divider></v-divider>
			<v-card-actions>
				<v-btn v-if="error" depressed color="error">
					<translate key="error">Error</translate>!
				</v-btn>
				<v-spacer></v-spacer>
				<v-btn v-if="!edit" color="primary darken-1" text @click="addRecord">
					<translate key="create-record">Create</translate>
				</v-btn>
        <v-btn v-else color="primary darken-1" text @click="editRecord">
					<translate key="edit-record">Save</translate>
				</v-btn>
				<v-btn color="primary darken-1" text @click="$emit('close')">
					<translate>Close</translate>
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
  name: "MonitoredSymptomRecord",
  props: {
    record: {
      default: () => ({
        date: "",
        time: "",
        intensity: 1
      })
    },
    edit: {
      default: false
    },
		show: {}
  },
  data: () => ({
    dateMenu: false,
    timeMenu: false,
    intensityColors: [
			"#4CAF50",
			"#66BB6A",
			"#A5D6A7",
			"#C8E6C9",
			"#FFF176",
			"#FFCC80",
			"#FF9800",
			"#F57C00",
			"#EF9A9A",
			"#E57373",
			"#F44336"
		],
		error: false
  }),
  computed: {
    dateRules() {
			return [v => !!v || this.$gettext("Date is required")];
		},
		timeRules() {
			return [v => !!v || this.$gettext("Time is required")];
		},
    intensityColor() {
			return this.intensityColors[this.record.intensity - 1];
		}
  },
  methods: {
    addRecord() {
      if (this.$refs.form.validate()) {
				this.error = false;
        this.$emit('add-record', this.record);
      }
    },
    editRecord() {
      if (this.$refs.form.validate()) {
				this.error = false;
        this.$emit('edit-record', this.record);
      }
    },
    getIntensityColor(intensity) {
			return this.intensityColors[intensity];
		},
		setError() {
			this.error = true;
		}
  },
  created() {
		if (!this.edit) {
			const now = new Date();
      var mm = now.getMonth() + 1;
      if(mm.toString().length < 2) mm = "0" + mm;
			var dd = now.getDate();
			var yy = now.getFullYear();
			this.record.date = yy + "-" + mm + "-" + dd;
			this.record.time = now.toLocaleTimeString('en-GB', {
				hour: "2-digit",
				minute: "2-digit"
			});
		}
	},
}
</script>